import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useToast } from "../../components/toast.tsx";
import { ApiError } from "../../lib/api.ts";

/** Runs a settings command; success toast only after the server confirms, then refreshes the plan's queries. */
export function useCommand(planId: string) {
  const qc = useQueryClient();
  const toast = useToast();
  const [busy, setBusy] = useState(false);
  async function run<T>(fn: () => Promise<T>, success: string, onError?: (e: ApiError) => boolean): Promise<T | undefined> {
    setBusy(true);
    try {
      const out = await fn();
      toast("success", success);
      await qc.invalidateQueries({ queryKey: ["plan", planId] });
      return out;
    } catch (e) {
      if (e instanceof ApiError && onError?.(e)) return undefined;
      if (e instanceof ApiError && e.code === "VERSION_CONFLICT") await qc.invalidateQueries({ queryKey: ["plan", planId] });
      toast("danger", e instanceof Error ? e.message : "Não foi possível concluir a operação.");
      return undefined;
    } finally {
      setBusy(false);
    }
  }
  return { run, busy };
}

/** Instructor view of archived settings rows (UX-26): read-only, shown greyed with a label. */
export function ArchivedToggle({ checked, onChange }: { checked: boolean; onChange: (v: boolean) => void }) {
  return (
    <label className="flex min-h-10 items-center gap-2 text-sm">
      <input type="checkbox" className="size-4 accent-primary" checked={checked} onChange={(e) => onChange(e.target.checked)} />
      Mostrar arquivados
    </label>
  );
}
